<template>
    <div>
        <div class="form-row">
            <div class="col col-12 col-md-3 d-flex flex-column" v-if="tem_fornecedor">
                <az-input
                    type="button-group"
                    :optionsList="[
                        { id: 'P', search: 'Paciente' }, 
                        { id: 'E', search: 'Empresa' },
                    ]"
                    v-model="dados.origem"
                    @input="trocar_origem()" />
            </div>
            <div class="col col-12" :class="tem_fornecedor ? 'col-md-6' : ( view ? '' : 'col-md-9' )" v-if="dados.origem == 'P'">
                <az-input 
                    placeholder="Informe o nome ou CPF do paciente..."
                    icon="fas fa-user"
                    type="autocomplete" 
                    optionsMode="aql"
                    service="pacientes.index"
                    optionsDisplay="search"
                    ref="info_paciente"
                    :edicao="!idpaciente"
                    v-model="dados.paciente" 
                    :optimized_ac="true"
                    @input="selecionarPaciente()">
                    <template v-slot:buttonposb>
                        <div class="input-group-append" v-if="!dados.paciente">
                            <button type="button" class="btn btn-outline-primary" @click="incluir_paciente()" title="Incluir paciente.">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                            </button>
                        </div>
                        <div class="input-group-append" v-else-if="dados.paciente && dados.paciente.id_pessoa">
                            <button type="button" class="btn btn-outline-primary" @click="verPerfil()" title="Histórico do paciente.">
                                <i class="fa-solid fa-id-badge"></i>
                            </button>
                        </div>
                    </template>
                </az-input>
            </div>
            <div class="col col-12 col-md-6" v-if="dados.origem == 'E'">
                <az-input
                    placeholder="Selecione a Empresa..."
                    icon="fas fa-building"
                    type="autocomplete" 
                    optionsMode="aql"
                    service="fornecedores.index"
                    :optionsParm="{ 
                        ativas: true, 
                        tem_plano: true, 
                    }"
                    v-model="dados.fornecedor" 
                    ref="fornecedor"
                    @selecionado="selecionarEmpresa()" />
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column" v-if="!view">
                <button type="button" class="btn btn-outline-success" :disabled="id_orcamento || !dados || ( !dados.paciente && !dados.fornecedor ) || !dados.pagamentos" @click="novo_adiantamento()">
                    Incluir Adiantamento
                </button>
            </div>
        </div>

        <template v-if="( !dados.paciente && !dados.fornecedor ) || !novo">

            <div class="progress mt-1 mb-2">
                <div class="indeterminate" v-if="$store.state.loading && ( lista && lista.length )"></div>
                <div class="determinate" v-else></div>
            </div>    

            <az-empty-state v-if="!dados || ( !dados.paciente && !dados.fornecedor ) || !dados.pagamentos" 
                :icon="dados.origem == 'E' ? 'fas fa-building' : 'fas fa-user'"
                :msg="( !dados.paciente && !dados.fornecedor ) 
                    ? ( dados.origem == 'E' ? 'Selecione a Empresa...' : 'Selecione o Paciente...' ) 
                    : ''" />

            <!-- Lista de agendas -->

            <template v-else>
                <div v-if="dados.orcamento" class="alert alert-info d-flex justify-content-between">
                    <div>
                        Orçamento: 
                        <a href="#" @click.prevent="abrir_orcamento(dados.orcamento)" class="card-link">
                            #{{ dados.orcamento.id_orcamento }}
                        </a>
                    </div>
                    <div> 
                        R$ {{ $util.formatMoeda(dados.orcamento.valor_final) }}
                    </div>
                </div>

                <ul class="nav nav-tabs" id="myTab" role="tablist">
                    <template v-if="dados.origem == 'P'">
                        <li class="nav-item" role="presentation" >
                            <a class="nav-link active" id="atend-tab" data-toggle="tab" href="#atend" role="tab" aria-controls="atend" aria-selected="true">
                                Atendimentos
                                <span class="badge badge-light" v-if="dados && dados.pagamentos && dados.pagamentos.atendimentos && dados.pagamentos.atendimentos.length">
                                    {{ dados.pagamentos.atendimentos.length }}
                                </span>
                            </a>
                        </li>
                        <li class="nav-item" role="presentation" v-if="!view">
                            <a class="nav-link" id="adiantamento-tab" data-toggle="tab" href="#adiantamento" role="tab" aria-controls="adiantamento" aria-selected="false">
                                Adiantamentos
                                <span class="badge badge-light" v-if="dados && dados.pagamentos && dados.pagamentos.adiantamentos && dados.pagamentos.adiantamentos.length">
                                    {{ dados.pagamentos.adiantamentos.length }}
                                </span>
                            </a>
                        </li>
                        <li class="nav-item" role="presentation" v-if="!view && lista_historico && lista_historico.length">
                            <a class="nav-link" id="historico-tab" data-toggle="tab" href="#historico" role="tab" aria-controls="historico" aria-selected="false">
                                Pagamentos
                                <span class="badge badge-light" v-if="lista_historico.length">
                                    {{ lista_historico.length }}
                                </span>
                            </a>
                        </li>
                    </template>
                    <template v-else>
                        <li class="nav-item" role="presentation">
                            <a class="nav-link active" id="adiantamento-tab" data-toggle="tab" href="#adiantamento" role="tab" aria-controls="adiantamento" aria-selected="false">
                                Adiantamentos
                                <span class="badge badge-light" v-if="dados && dados.pagamentos && dados.pagamentos.adiantamentos && dados.pagamentos.adiantamentos.length">
                                    {{ dados.pagamentos.adiantamentos.length }}
                                </span>
                            </a>
                        </li>
                    </template>
                    <li class="nav-item" role="presentation" v-if="!view && lista_pendentes.length">
                        <a class="nav-link" id="pendente-tab" data-toggle="tab" href="#pendente" role="tab" aria-controls="profile" aria-selected="false">
                            Pendentes
                            <span class="badge badge-light" v-if="lista_pendentes.length">
                                {{ lista_pendentes.length }}
                            </span>
                        </a>
                    </li>
                    <li class="nav-item" role="presentation" v-if="false">
                        <a class="nav-link" id="teste-tab" data-toggle="tab" href="#teste" role="tab" aria-controls="profile" aria-selected="false">Teste</a>
                    </li>
                </ul>
                <div class="tab-content" id="myTabContent">
                    <!-- ATENDMENTOS -->
                    <div class="tab-pane fade show active" id="atend" role="tabpanel" aria-labelledby="atend-tab" v-if="dados.origem == 'P'">

                        <div v-if="dados.pagamentos && dados.pagamentos.atendimentos && dados.pagamentos.atendimentos.length">
                            <table class="table bg-white" v-if="dados.pagamentos && dados.pagamentos.atendimentos">
                                <thead>
                                    <tr class="table-info">
                                        <td>
                                            &nbsp;
                                        </td>
                                        <td >
                                            {{ view ? 'Total' : 'Selecionado' }}
                                        </td>
                                        <td>
                                            <button type="button" class="btn btn-sm btn-primary" 
                                                v-if="!view && total_selecionado > 0 && dados && dados.pagamentos && dados.pagamentos.multiplo"
                                                @click="registrar_pagamento()">
                                                Registrar Pagamento
                                            </button>
                                        </td>
                                        <td class="text-right">
                                            <span v-if="total_selecionado > 0">
                                                {{ $util.formatMoeda(total_selecionado) }}
                                            </span>
                                        </td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(atend, iax) in dados.pagamentos.atendimentos" :key="iax">
                                        <td class="text-center">
                                            <span v-if="view">
                                                <a href="#" @click.prevent="$emit('atendselec', atend)">
                                                    <i class="fa-solid fa-circle-exclamation text-warning fa-2x" v-if="atend.pagamento && atend.pagamento.item_pagamento_atendimento_ativos_com_desconto && !atend.pagamento.item_pagamento_atendimento_ativos_com_desconto.length"></i>
                                                    <i class="fa fa-check-circle text-success fa-2x" v-else-if="atend.pagamento"></i>
                                                    <i class="fa-solid fa-circle text-primary fa-2x" v-else></i>
                                                </a>
                                            </span>
                                            <span v-else-if="atend.pagamento">
                                                <i class="fa-solid fa-circle-exclamation text-warning fa-2x" v-if="atend.pagamento.item_pagamento_atendimento_ativos_com_desconto && !atend.pagamento.item_pagamento_atendimento_ativos_com_desconto.length"></i>
                                                <i class="fa fa-check-circle text-success fa-2x" aria-hidden="true" v-else></i>
                                                <div class="small text-muted">
                                                    <a href="#" @click.prevent="abrir_pagamento(atend.pagamento.id_pagamento_atendimento)" class="card-link">
                                                        #{{ atend.pagamento.id_pagamento_atendimento }}
                                                    </a>
                                                </div>
                                            </span>
                                            <span v-else>
                                                <input type="checkbox" class="form form-control" 
                                                    v-model="atend.marcacao.status_confirmacao" />

                                                <template v-if="!dados || !dados.pagamentos || !dados.pagamentos.multiplo">
                                                    <a href="#" @click.prevent="registrar_pagamento(atend)">
                                                        Registrar Pagamento
                                                    </a>
                                                </template>
                                            </span>
                                        </td>
                                        <td>
                                            <div>
                                                {{ $util.getFormatDate(atend.dt_inicio) }}
                                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                <a href="#" @click.prevent="abrir_atendimento(atend.id_atendimento)" class="card-link" v-if="!view">
                                                    #{{ atend.id_atendimento }}
                                                </a>
                                                <span v-else>
                                                    #{{ atend.id_atendimento }}
                                                </span>
                                            </div>
                                            <div class="text-muted">
                                                {{ atend.plano.search }}
                                            </div>
                                        </td>
                                        <td>
                                            {{ atend.marcacao.procedimento.search }}
                                            <span class="badge badge-primary ml-1" v-if="atend.atendimento_procedimentos && atend.atendimento_procedimentos.length > 1">
                                                <i class="fa fa-plus" aria-hidden="true"></i>
                                                {{ atend.atendimento_procedimentos.length - 1 }}
                                            </span>
                                            <div class="text-muted">{{ atend.marcacao.medico.st_nome_exibicao }}</div>
                                        </td>
                                        <td class="text-right">
                                            <div>
                                                <span v-if="atend.valor_total_calculado">
                                                    {{ $util.formatMoeda(atend.valor_total_calculado.valor) }}
                                                </span>
                                                <span v-else>
                                                    {{ $util.formatMoeda(total(atend.atendimento_procedimentos, 'cd_valor_total')) }}
                                                </span>
                                            </div>

                                            <div v-if="atend.pagamento && atend.pagamento.dt_data.slice(0, 10) != atend.dt_inicio.slice(0, 10)" class="badge badge-warning" title="Data do Pagamento">
                                                {{ $util.getFormatDate(atend.pagamento.dt_data) }}
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div v-else>
                            <div>
                                <az-empty-state msg="Nenhum atendimento particular identificado" icon="fa fa-play-circle" />
                            </div>
                        </div>
                    </div>

                    <!-- Adiantamentos -->
                    <div class="tab-pane fade" :class="dados.origem == 'E' ? 'show active' : ''" id="adiantamento" role="tabpanel" aria-labelledby="adiantamento-tab">
                        <div v-if="dados && dados.pagamentos && dados.pagamentos.adiantamentos && dados.pagamentos.adiantamentos.length">

                            <div id="lista-adiantamentos">

                                <cabecalho-generico titulo="Adiantamentos">
                                    <div v-if="dados.fornecedor">
                                        Empresa: {{ dados.fornecedor.search }}
                                    </div>
                                    <div v-if="dados.paciente">
                                        Paciente: {{ dados.paciente.search }}
                                    </div>
                                </cabecalho-generico>

                                <table class="table bg-white">
                                    <thead>
                                        <tr>
                                            <th width="25%">Id</th>
                                            <th width="25%">Data</th>
                                            <th width="25%" class="text-right">Valor</th>
                                            <th width="25%" class="text-right">Saldo</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-for="(adiantamento, iax) in dados.pagamentos.adiantamentos">
                                            <tr v-if="true" :key="'A' + iax" :class="!adiantamento.saldo_adiantamento ? ( !adiantamento.fl_ativo ? 'table-warning' : 'table-danger' ) : ''">
                                                <td>
                                                    <a href="#" @click.prevent="adiantamento.selecionado = !adiantamento.selecionado" class="card-link mr-2">
                                                        <i class="fa fa-plus-square-o" v-if="!adiantamento.selecionado"></i>
                                                        <i class="fa fa-minus-square-o" v-else></i>
                                                    </a>
                                                    <a href="#" @click.prevent="abrir_pagamento(adiantamento.id_pagamento_atendimento)" class="card-link">
                                                        #{{ adiantamento.id_pagamento_atendimento }}
                                                    </a>
                                                    <span class="badge badge-light ml-1" v-if="adiantamento.unidade_operacao">
                                                        {{ adiantamento.unidade_operacao.st_sigla }}
                                                    </span>
                                                    <span v-if="adiantamento.st_id_externo" class="small text-muted ml-3">
                                                        Pag.: {{ adiantamento.st_id_externo }}
                                                    </span>
                                                </td>
                                                <td>
                                                    {{ $util.getFormatDate(adiantamento.dt_data) }}
                                                    <div class="small text-muted" v-if="adiantamento.orcamentos && adiantamento.orcamentos.length">
                                                        Orçamento: 
                                                        <a href="#" @click.prevent="abrir_orcamento(orc)" class="card-link mr-2" v-for="(orc, iox) in adiantamento.orcamentos" :key="iox">
                                                            #{{ orc.id_orcamento }}
                                                        </a>

                                                        <span v-if="adiantamento.medico" class="text-muted">{{ adiantamento.medico.search }}</span>
                                                    </div>
                                                </td>
                                                <td class="text-right">
                                                    {{ $util.formatMoeda(adiantamento.dc_valor_adiantado) }}
                                                    <div v-if="adiantamento.valor_pendente">
                                                        <a href="#" @click.prevent="go_to_pendentes()">
                                                            <span class="badge badge-warning" title="Valor Pendente.">
                                                                Pendente: {{ $util.formatMoeda(adiantamento.valor_pendente) }}
                                                            </span>
                                                        </a>
                                                    </div>
                                                    <div v-if="adiantamento.valor_quitado">
                                                        <span class="badge badge-danger" title="Valor Quitado.">
                                                            Quitado: {{ $util.formatMoeda(adiantamento.valor_quitado) }}
                                                        </span>
                                                    </div>
                                                </td>
                                                <td class="text-right">
                                                    {{ $util.formatMoeda(adiantamento.saldo_adiantamento) }}
                                                    <a href="#" @click.prevent="toggle_adiantamento(adiantamento)" class="card-link" title="Adiantamento em aberto." data-toggle="tooltip" data-placement="left" v-if="adiantamento.saldo_adiantamento > 0">
                                                        <i class="fas fa-door-open fa-fw ml-2"></i>
                                                    </a>
                                                    <a href="#" @click.prevent="toggle_adiantamento(adiantamento)" class="card-link" title="Adiantamento encerrado." data-toggle="tooltip" data-placement="left" v-else>
                                                        <i class="fas fa-door-closed fa-fw ml-2"></i>
                                                    </a>

                                                    <a href="#" @click.prevent="integrar_adiantamento_labs(adiantamento)" class="card-link ml-3" v-if="is_labs && !adiantamento.st_id_externo" title="Integrar adiantamento.">
                                                        <i class="fa-solid fa-right-left"></i>
                                                    </a>
                                                </td>
                                            </tr>

                                            <template v-if="adiantamento.selecionado">
                                                <tr :key="'C' + iax" class="table-info">
                                                    <td colspan="4">Composição</td>
                                                </tr>
                                                <tr :key="'O' + iax" class="table-info" v-if="adiantamento.orcamentos && adiantamento.orcamentos.length">
                                                    <td colspan="4" class="table-info">
                                                        <div class="d-flex justify-content-between" v-for="(orcamento, iox) in adiantamento.orcamentos" :key="iox">
                                                            <div>
                                                                Orçamento 
                                                                <a href="#" @click.prevent="abrir_orcamento(orcamento)" class="card-link">
                                                                    #{{ orcamento.id_orcamento }}
                                                                </a>
                                                            </div>
                                                            <div>
                                                                R$ {{ $util.formatMoeda(orcamento.valor_final) }}
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr :key="'CI' + iax">
                                                    <td colspan="4">
                                                        <table class="table table-sm">
                                                            <tr v-for="(itp, itx) in adiantamento.item_pagamento_atendimentos" :key="itx">
                                                                <td width="40%">{{ itp.forma_pagamento.search }}</td>
                                                                <td width="35%">
                                                                    <span v-if="itp.bandeira_cartao">
                                                                        {{ itp.bandeira_cartao.search }}
                                                                        <div class="small">
                                                                            {{ itp.st_autorizacao }}
                                                                        </div>
                                                                    </span>
                                                                </td>
                                                                <td width="25%" class="text-right">
                                                                    {{ $util.formatMoeda(itp.dc_valor) }}
                                                                    <i class="fas fa-minus-circle fa-fw text-danger ml-2" v-if="itp.id_forma_pagamento == 94"></i>
                                                                    <i class="fas fa-plus-circle fa-fw text-success ml-2" v-else></i>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                        
                                                        <pre v-if="false">{{ itp }}</pre>
                                                    </td>
                                                </tr>
                                            
                                                <template v-if="adiantamento.adiantamento_usos.length">
                                                    <tr :key="'U' + iax" class="table-info">
                                                        <td colspan="4">Uso</td>
                                                    </tr>
                                                    <tr :key="'UI' + iax">
                                                        <td colspan="4">
                                                            <table class="table">
                                                                <tr v-for="(itp, itx) in adiantamento.adiantamento_usos" :key="itx">
                                                                    <td width="25%">
                                                                        #{{ itp.pagamento_atendimento.id_atendimento }}
                                                                    </td>
                                                                    <td width="50%">
                                                                        {{ $util.getFormatDate(itp.pagamento_atendimento.dt_data) }}
                                                                        <span v-if="dados.origem == 'E' && itp.pagamento_atendimento.atendimento && itp.pagamento_atendimento.atendimento.paciente">
                                                                            <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                                            {{ itp.pagamento_atendimento.atendimento.paciente.st_nome }}
                                                                        </span>
                                                                    </td>
                                                                    <td width="25%" class="text-right">
                                                                        {{ $util.formatMoeda(itp.dc_valor) }}
                                                                        <i class="fas fa-minus-circle fa-fw text-danger ml-2"></i>
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </template>

                                                <template v-if="adiantamento.abatimentos && adiantamento.abatimentos.length">
                                                    <tr :key="'UA' + iax" class="table-info">
                                                        <td colspan="4">Abatimentos</td>
                                                    </tr>
                                                    <tr :key="'UAI' + iax">
                                                        <td colspan="4">
                                                            <table class="table">
                                                                <tr v-for="(abt, itx) in adiantamento.abatimentos" :key="itx">
                                                                    <td width="25%">
                                                                        <a href="#" @click.prevent="remover_abatimento(abt)" class="card-link mr-3">
                                                                            <i class="fa-solid fa-trash-can text-danger"></i>
                                                                        </a>
                                                                        #{{ abt.id_pagamento_atendimento_abatimento }}
                                                                    </td>
                                                                    <td width="50%">
                                                                        {{ $util.getFormatDate(abt.created_at) }}
                                                                        <div class="small text-muted" v-if="abt.usuario && abt.usuario.pessoa">
                                                                            Por: {{ abt.usuario.pessoa.st_nome }}
                                                                        </div>
                                                                        <div class="small text-muted" v-if="abt.st_observacoes">
                                                                            {{ abt.st_observacoes }}
                                                                        </div>
                                                                    </td>
                                                                    <td width="25%" class="text-right">
                                                                        {{ $util.formatMoeda(abt.dc_valor) }}
                                                                        <i class="fas fa-minus-circle fa-fw text-danger ml-2"></i>
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </template>
                                        </template>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <th width="50%" colspan="2">Total</th>
                                            <th width="25%" class="text-right">
                                                {{ $util.formatMoeda(total_valor_adiantamento) }} 
                                            </th>
                                            <th width="25%" class="text-right">
                                                {{ $util.formatMoeda(total_saldo_adiantamento) }}
                                            </th>
                                        </tr>
                                    </tfoot>
                                </table>

                            </div>

                            <print-export printid="lista-adiantamentos" />

                        </div>

                        <div v-else>
                            <div>
                                <az-empty-state msg="Nenhum adiantamento identificado" icon="fas fa-money-check-alt" />
                            </div>
                        </div>
                    </div>

                    <!-- Pendentes -->
                    <div class="tab-pane fade" id="pendente" role="tabpanel" aria-labelledby="pendente-tab">
                        <div v-if="lista_pendentes.length">
                            <ul class="list-group">
                                <li class="list-group-item d-flex justify-content-between" v-for="(pendente, ipx) in lista_pendentes" :key="ipx">
                                    <div>
                                        <template v-if="pendente.id_atendimento">
                                            <a href="#" @click.prevent="abrir_atendimento(pendente.id_atendimento)">
                                                {{ pendente.num_atend }}
                                            </a>
                                        </template>
                                        <template v-else-if="pendente.dc_valor_adiantado">
                                            Adiantamento 
                                            <a href="#" @click.prevent="abrir_pagamento(pendente.id_pagamento_atendimento)" class="card-link">
                                                #{{ pendente.id_pagamento_atendimento }}
                                            </a>
                                        </template>
                                        <div>
                                            {{ $util.getFormatDate(pendente.dt_data) }}
                                        </div>
                                        <div class="small text-muted" v-if="pendente.orcamentos && pendente.orcamentos.length">
                                            Orçamento: 
                                            <a href="#" @click.prevent="abrir_orcamento(orc)" class="card-link mr-2" v-for="(orc, iox) in pendente.orcamentos" :key="iox">
                                                #{{ orc.id_orcamento }}
                                            </a>
                                        </div>
                                    </div>
                                    <div>
                                        {{ $util.formatMoeda(total(pendente.item_pagamento_atendimentos, 'dc_valor')) }}
                                        <button type="button" class="btn btn-primary ml-3" @click="pagar_pendente(pendente)">
                                            Pagar
                                        </button>
                                    </div>
                                </li>
                            </ul>
                            <pre class="alert alert-warning" v-if="false">{{ lista_pendentes }}</pre>
                        </div>
                    </div>

                    <!-- Histórico de Pagamentos -->
                    <div class="tab-pane fade" id="historico" role="tabpanel" aria-labelledby="historico-tab">
                        <div v-if="lista_historico.length" id="lista-pagamentos">

                            <cabecalho-generico titulo="Histórico de Pagamentos">
                                <div v-if="dados.fornecedor">
                                    Empresa: {{ dados.fornecedor.search }} ({{ dados.fornecedor.id_fornecedor }})
                                </div>
                                <div v-if="dados.paciente">
                                    Paciente: {{ dados.paciente.search }} ({{ dados.paciente.id_pessoa }})
                                </div>
                            </cabecalho-generico>

                            <ul class="list-group">
                                <li class="list-group-item" v-for="(pagamento, ipx) in lista_historico" :key="ipx">
                                    <div class="d-flex justify-content-between">
                                        <div>
                                            <a href="#" class="card-link mr-2" @click.prevent="pagamento.selec = !pagamento.selec">
                                                <i class="fa-regular fa-square-plus" v-if="!pagamento.selec"></i>
                                                <i class="fa-regular fa-square-minus" v-else></i>
                                            </a>
                                            <template v-if="pagamento.id_atendimento">
                                                Atendimento 
                                                <a href="#" @click.prevent="abrir_atendimento(pagamento.id_atendimento)" class="card-link">
                                                    {{ pagamento.num_atend }}
                                                </a>
                                                <span v-if="pagamento.marcacao && pagamento.marcacao.unidade_operacao && pagamento.marcacao.unidade_operacao.st_sigla" class="badge badge-light ml-3">
                                                    {{ pagamento.marcacao.unidade_operacao.st_sigla }}
                                                </span>
                                            </template>
                                            <template v-else-if="pagamento.dc_valor_adiantado">
                                                Adiantamento 
                                                <a href="#" @click.prevent="abrir_pagamento(pagamento.id_pagamento_atendimento)" class="card-link">
                                                    #{{ pagamento.id_pagamento_atendimento }}
                                                </a>
                                                <span v-if="pagamento.unidade && pagamento.unidade.st_sigla" class="badge badge-light ml-3">
                                                    {{ pagamento.unidade.st_sigla }}
                                                </span>
                                            </template>
                                            <template v-else-if="pagamento.id_pagamento_atendimento">
                                                Pagamento 
                                                <a href="#" @click.prevent="abrir_pagamento(pagamento.id_pagamento_atendimento)" class="card-link">
                                                    #{{ pagamento.id_pagamento_atendimento }}
                                                </a>
                                                <span v-if="pagamento.unidade && pagamento.unidade.st_sigla" class="badge badge-light ml-3">
                                                    {{ pagamento.unidade.st_sigla }}
                                                </span>
                                            </template>
                                            <div>
                                                {{ $util.getFormatDate(pagamento.dt_data) }}
                                            </div>
                                            <div class="small text-muted" v-if="pagamento.orcamentos && pagamento.orcamentos.length">
                                                Orçamento: 
                                                <a href="#" @click.prevent="abrir_orcamento(orc)" class="card-link mr-2" v-for="(orc, iox) in pagamento.orcamentos" :key="iox">
                                                    #{{ orc.id_orcamento }}
                                                </a>
                                            </div>
                                        </div>
                                        <div class="text-right">
                                            {{ $util.formatMoeda(total(pagamento.item_pagamento_atendimentos, 'dc_valor')) }}
                                            <div class="small text-muted">
                                                {{ lista_formas(pagamento)}}
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="pagamento.selec">
                                        <table class="table table-sm mt-2">
                                            <thead>
                                                <tr>
                                                    <th>Forma de Pagamento</th>
                                                    <th class="text-right">Valor</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(forma, ifx) in pagamento.item_pagamento_atendimentos" :key="ifx">
                                                    <td>
                                                        {{ forma.forma_pagamento.search }}
                                                    </td>
                                                    <td class="text-right">
                                                        {{ $util.formatMoeda(forma.dc_valor) }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </li>
                            </ul>

                            <div class="alert alert-info d-flex justify-content-between">
                                <div>
                                    Total: 
                                </div>
                                <div>
                                    {{ $util.formatMoeda(total(lista_historico.flatMap(pag => pag.item_pagamento_atendimentos), 'dc_valor')) }}
                                </div>
                            </div>
                            <pre class="alert alert-warning" v-if="false">{{ lista_historico }}</pre>
                        </div>

                        <print-export printid="lista-pagamentos" />

                    </div>

                    <!-- Teste -->
                    <div class="tab-pane fade" id="teste" role="tabpanel" aria-labelledby="teste-tab">
                        <div class="mt-3 alert alert-info" id="lista-de-trabalho">
                            <pre>{{ dados }}</pre>
                        </div>        
                    </div>
                </div>

            </template>

        </template>

        <template v-else>

            <div class="card mt-3" v-if="!refresh_pag">
                <div class="card-body pt-0">
                    <pagamento ref="pag" @refresh="load()">
                        <div v-if="dados.orcamento" class="mt-3 alert alert-info d-flex justify-content-between">
                            <div>
                                Orçamento: 
                                <a href="#" @click.prevent="abrir_orcamento(dados.orcamento)" class="card-link">
                                    #{{ dados.orcamento.id_orcamento }}
                                </a>
                            </div>
                            <div> 
                                R$ {{ $util.formatMoeda(dados.orcamento.valor_final) }}
                            </div>
                        </div>
                    </pagamento>
                </div>
            </div>

            <br><br><br><br><br>

            <nav class="navbar fixed-bottom navbar-light bg-light">
                <div>
                    <az-submit @click="salvar_pagamento()">Registrar</az-submit>
                    <button type="button" class="btn btn-secondary ml-2" @click="novo = null">
                        Voltar
                    </button>
                    <button type="button" class="btn btn-outline-primary mx-2" @click="abrir_recibo()">
                        Recibo
                    </button>
                    <az-audit-log-button model="pagamentoAtendimento" :id="id_pagamento_atendimento_selec" />
                </div>
            </nav>

        </template>

        <!-- Modal Recibo -->
        <div class="modal fade" id="reciboModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Recibo</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="recibo_marcacao">
                            <recibo-particular2 ref="recibo" @precisa_concluir="set_precisa_concluir" />
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <button type="button" class="btn btn-success" @click="imprimir_recibo()">Imprimir</button>
                        <button type="button" class="btn btn-outline-success" @click="concluir()" v-if="precisa_concluir">Concluir</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Valor Adiantamento Modal -->
        <div class="modal fade" id="valorAdiantamentoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="valor_do_adiantamento !== null">
                    <div class="modal-header">
                        <h5 class="modal-title">Valor do Adiantamento</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row" v-if="is_labs">
                            <div class="col col-12">
                                <az-input
                                    label="Particular"
                                    type="select"
                                    service="planos.index"
                                    optionsMode="aql"
                                    optionsName="planos.particular.ad"
                                    optionsData="id_plano"
                                    :optionsParm="{ 
                                        where: { id_operadora: 1 }, 
                                        id_unidade_operacao: $util.unidade_operacao() ? $util.unidade_operacao().id_unidade_operacao : null, 
                                        particular: true 
                                    }"
                                    placeholder="Selecione..."
                                    required
                                    :validate="validate"
                                    v-model="id_plano_particular" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Valor"
                                    type="money"
                                    required
                                    :validate="validate"
                                    v-model="valor_do_adiantamento" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Data"
                                    type="date"
                                    required
                                    :validate="validate"
                                    v-model="data_do_adiantamento" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Profissional (Opcional)"
                                    type="autocomplete"
                                    placeholder="Não definido..."
                                    optionsMode="aql"
                                    service="medicos.index"
                                    optionsDisplay="st_nome_exibicao"
                                    v-model="medico_adiantamento" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <button type="button" class="btn btn-success" @click="novo_adiantamento(valor_do_adiantamento)">Incluir</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Toggle Adiantamento -->
        <div class="modal fade" id="toggleAdiantamentoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="ad_para_fechar">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Adiantamento
                            <span class="badge badge-secondary">
                                #{{ ad_para_fechar.id_pagamento_atendimento }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-primary">
                            Saldo: {{ $util.formatMoeda(ad_para_fechar.saldo_adiantamento) }}
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input 
                                    label="Observações"
                                    type="textarea"
                                    v-model="ad_para_fechar.st_observacoes" />
                            </div>
                        </div>

                        <template v-if="ad_para_fechar.fl_ativo">

                            <div class="row mt-3">
                                <div class="col col-12">
                                    <az-input
                                        type="button-group"
                                        :optionsList="[
                                            { id: 'T', search: 'Total' },
                                            { id: 'P', search: 'Parcial' },
                                        ]"
                                        v-model="ad_para_fechar.escopo" />
                                </div>
                            </div>

                            <div class="row" v-if="ad_para_fechar.escopo == 'P'">
                                <div class="col col-12">
                                    <az-input
                                        type="money"
                                        label="Valor de Abatimento"
                                        v-model="ad_para_fechar.escopo_valor" />
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="salvar_toggle_adiantamento(ad_para_fechar)"
                            :color="ad_para_fechar.fl_ativo ? 'danger' : 'success'">
                            {{ ad_para_fechar.fl_ativo ? 'Encerrar' : 'Reabrir' }}
                        </az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="novoPacienteAdiantamentoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content" v-if="dados_novo_paciente">
                    <div class="modal-header">
                        <h5 class="modal-title">Incluir Paciente</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-2" v-if="!dados_novo_paciente.id_pessoa && !dados_novo_paciente.verificado">
                            <cadastro-paciente-primeira-vez ref="cadPaciente1" :direto="true" v-model="dados_novo_paciente" />
                        </div>
                        <div class="mb-2" v-else>
                            <cadastro-paciente
                                v-model="dados_novo_paciente"
                                formName="cadpac"
                                :editar="true"
                                :noButtons="true"
                                ref="cadPaciente"
                                :validate="validate"
                            />
                        </div>

                        
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit v-if="dados_novo_paciente.verificado" @click="salvar_paciente()">Incluir</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>


</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import Pagamento from './Pagamento.vue';
import ReciboParticular2 from './ReciboParticular2.vue';
import PrintExport from '../../shared/PrintExport.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';
import CadastroPacientePrimeiraVez from './CadastroPacientePrimeiraVez.vue';
import CadastroPaciente from "../../shared/CadastroPaciente.vue";
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';

export default {
    data() { 
        return { 
            dados: { 
                paciente: "",
                fornecedor: "", 
                pagamentos: null,
                origem: "P",
            },
            canceltoken: null, 
            etiqueta_layouts: [],
            layout: "", 
            novo: false, 
            valor_do_adiantamento: null, 
            data_do_adiantamento: null, 
            id_plano_particular: "", 
            recibo_marcacao: null, 
            ad_para_fechar: null, 
            tem_fornecedor: false, 
            orcamento_carregado: false, 
            validate: false, 
            dados_novo_paciente: null, 
            primeira_vez: true,
            refresh_pag: false,
            medico_adiantamento: "", 
            id_pagamento_atendimento_selec: null,
            precisa_concluir: false, 
        };
    },

    props: [
        'idpaciente',
        'id_orcamento',
        'id_marcacao',
        'id_pagamento_atendimento', 
        'view', 
    ],

    components: { 
        AzInput, 
        AzEmptyState, 
        Pagamento, 
        ReciboParticular2, 
        AzSubmit, 
        PrintExport, 
        CabecalhoGenerico,
        CadastroPacientePrimeiraVez,
        CadastroPaciente,
        AzAuditLogButton
    },

    computed: { 
        is_callcenter: function () { 
            return this.$route.path.slice(0,12) == '/call-center' ? true : false; 
        },

        is_labs: function () { 
            return window.redir == 'labs' || window.redir == 'teste';
        },

        total_valor_adiantamento: function () {
            if ( !this.dados || !this.dados.pagamentos || !this.dados.pagamentos.adiantamentos ) { 
                return 0;
            } 

            return this.dados.pagamentos.adiantamentos.reduce((total, carry) => { 
                return total + carry.dc_valor_adiantado
            }, 0);
        },

        total_saldo_adiantamento: function () { 
            if ( !this.dados || !this.dados.pagamentos || !this.dados.pagamentos.adiantamentos ) { 
                return 0;
            } 

            return this.dados.pagamentos.adiantamentos.reduce((total, carry) => { 
                return total + carry.saldo_adiantamento;
            }, 0);
        },

        lista: function () { 
            return this.dados.laudos;
        },

        lista_agrupada: function () { 
            return _.groupBy(this.lista, (item) => {
                return item.atendimento_procedimento.procedimento.id_especialidade == 2 
                    ? 'L' + item.atendimento_procedimento.id_atendimento 
                    : item.atendimento_procedimento.id_atendimento_procedimento;
            });
        },

        total_selecionado: function() { 
            if ( !this.dados || !this.dados.pagamentos )
                return 0;

            // return this.dados.pagamentos.atendimentos.filter(item => item.marcacao.status_confirmacao).length

            return _.sumBy(
                this.dados.pagamentos.atendimentos.filter(item => this.view || item.marcacao.status_confirmacao),
                atd => { 
                    return _.sumBy(atd.atendimento_procedimentos, 'cd_valor_total');
                }
            );
            
        },

        lista_pendentes: function () { 
            if ( !this.dados || !this.dados.pagamentos || !this.dados.pagamentos.realizados ) { 
                return [];
            }

            return this.dados.pagamentos.realizados.filter(item => item.item_pagamento_atendimentos.length);
        },

        lista_historico: function () { 
            if ( !this.dados || !this.dados.pagamentos || !this.dados.pagamentos.historico ) { 
                return [];
            }

            return this.dados.pagamentos.historico;
        }
    },

    methods: { 
        concluir () { 
            this.$refs.recibo.concluir(); 
        },

        set_precisa_concluir (valor) { 
            this.precisa_concluir = valor;
        },

        lista_formas (pagamento) { 
            let formas = pagamento.item_pagamento_atendimentos.map(item => item.forma_pagamento.search);
            return _.uniq(formas.sort()).join(', ');
        },

        verPerfil() { 
            $('.modal').modal('hide');
            this.$root.perfil(this.dados.paciente);
        },

        salvar_paciente () {

            this.$util.atualizar(this, { 
                service: 'pacientes', 
                func: 'store',
                dados: { 
                    paciente: this.dados_novo_paciente,
                },
                modal: 'novoPacienteAdiantamentoModal',
                callback: res => { 
                    this.dados.paciente = res;
                }
            });
    
        },

        incluir_paciente () { 
            this.validate = false; 
            this.dados_novo_paciente = null;

            this.$nextTick(() => { 
                this.dados_novo_paciente = { 
                    id_pessoa: null,
                    verificado: false, 
                    st_nome: "", 
                    cpf_nao_obrigatorio: false, 
                    cadastro: { 
                        ch_sexo: "",
                        dt_nascimento: "", 
                        fl_estrangeiro: false, 
                        st_cpf: "", 
                        st_nome_mae: "",
                        st_rg: "", 
                        telefones: { 
                            telefone: "",
                            celular: "", 
                        },
                        endereco: { 
                            cidade: null, 
                        }, 
                    },
                    paciente_unidade: { 
                        st_numero_carteira: "", 
                        dt_validade_carteira: "",
                        st_numero_prontuario: "", 
                    },
                };

                $('#novoPacienteAdiantamentoModal').modal('show');
            })
        },

        go_to_pendentes () { 
            $('#myTab a[href="#pendente"]').tab('show');
        },

        integrar_adiantamento_labs (adiantamento) { 
            if ( this.$store.state.loading )
                return; 

            this.$util.atualizar(this, { 
                service: 'terceiros', 
                func: 'integrar_adiantamento_labs', 
                dados: { 
                    id_pagamento_atendimento: adiantamento.id_pagamento_atendimento,
                },
                toast: true, 
                reload: true, 
            });
        },

        abrir_orcamento(orcamento) { 
            if ( this.is_callcenter ) { 
                this.$router.push({ name: 'orcamento', params: { id_orcamento: orcamento.id_orcamento }});
            } else { 
                this.$router.push({ name: 'rorcamento', params: { id_orcamento: orcamento.id_orcamento }});
            }
        },

        remover_abatimento (abt) { 
            if ( !confirm('Confirma remover o abatimento do adiantamento?') ) { 
                return;
            }

            this.$util.atualizar(this, { 
                service: 'pagamentos', 
                func: 'remover_abatimento', 
                dados: { 
                    id_pagamento_atendimento_abatimento: abt.id_pagamento_atendimento_abatimento,
                },
                toast: true,
                reload: true, 
            });
        },

        trocar_origem() { 
            this.dados.paciente = null;
            this.dados.fornecedor = null;
        },

        selecionarEmpresa () { 
            this.dados.paciente = null;
            this.novo = null;

            this.$nextTick(() => { 
                this.load();
            });
        },

        abrir_atendimento (id) { 
            this.$util.abrir_atendimento(this, id);
        },

        toggle_adiantamento (item) { 
            let info = _.cloneDeep(item);

            info.escopo = "T";
            info.escopo_valor = 0;

            this.ad_para_fechar = info;
            
            $('#toggleAdiantamentoModal').modal('show');
        },

        salvar_toggle_adiantamento (item) { 
            this.$util.atualizar(this, { 
                service: 'pagamentos',
                func: 'toggle_adiantamento',
                dados: { 
                    id_pagamento_atendimento: item.id_pagamento_atendimento,
                    obs: item.st_observacoes, 
                    escopo: item.escopo,
                    escopo_valor: item.escopo_valor, 
                },
                toast: true,
                modal: 'toggleAdiantamentoModal', 
                callback: () => { 
                    this.load(true);
                }
            });
        },

        imprimir_recibo () { 
            this.$refs.recibo.imprimirRecibo();
        },

        abrir_recibo (id_pagamento_atendimento = null) { 
            if ( !id_pagamento_atendimento && this.novo ) { 
                id_pagamento_atendimento = this.$refs.pag.id_pagamento_atendimento;
            }

            if ( !id_pagamento_atendimento ) { 
                this.$toast.add({
                    severity: "warn",
                    summary: 'Recibo',
                    detail: 'Pagamento ainda não registrado.',
                    life: 3000
                });
                return;
            }
            this.recibo_marcacao = null;

            this.$nextTick(() => { 
                if ( this.novo ) { 
                    this.recibo_marcacao = this.$refs.pag.atendimento.marcacao;
                } else { 
                    this.recibo_marcacao = null;
                }

                this.$nextTick(() => { 
                    this.$refs.recibo.abrir(id_pagamento_atendimento);
                });
                
                $('#reciboModal').modal('show');
            });
        },

        abrir_pagamento(id) { 
            this.novo = true;

            this.$nextTick(() => { 
                this.id_pagamento_atendimento_selec = id; 
                this.$refs.pag.abrir_pagamento(id);
            });
        },

        salvar_pagamento() { 
            this.$refs.pag.atualizar(
                    (res) => {
                        if ( res.id_pagamento_atendimento ) { 
                            this.abrir_recibo(res.id_pagamento_atendimento);

                            this.$nextTick(() => { 

                                if ( this.pag_pendente ) { 

                                    $('.modal').modal('hide');
                                    this.novo = null; 

                                } else { 

                                    this.novo = true;
                                    
                                    this.$nextTick(() => { 
                                        this.$refs.pag.abrir_pagamento(res.id_pagamento_atendimento);
                                    });

                                }

                            });
                        }
                    },
                    () => {
                        // this.novo = null;
                        this.load();
                    }
                );
        },

        total(lista, campo) { 
            return _.sumBy(lista, campo);
        },

        registrar_pagamento(atendimento = null) { 
            if ( atendimento ) { 
                this.novo = true;

                this.$nextTick(() => { 
                    this.$refs.pag.abrir(atendimento.id_atendimento);
                });
                return;
            }

            const selecionados = this.dados.pagamentos.atendimentos.filter(
                item => item.marcacao.status_confirmacao
            );
            
            if ( selecionados.length == 1 ) { 
                this.novo = true;

                this.$nextTick(() => { 
                    this.$refs.pag.abrir(selecionados[0].id_atendimento);
                });
            } else if ( selecionados.length > 1 ) { 
                this.novo = true;

                this.$nextTick(() => { 
                    this.$refs.pag.abrir_mult(selecionados[0].id_atendimento, selecionados);
                });
            }
        },

        pagar_pendente(pendente) { 
            this.novo_adiantamento(this.total(pendente.item_pagamento_atendimentos, 'dc_valor'), pendente);
        },

        novo_adiantamento(valor = null, pendente = null) {
            this.pag_pendente = pendente ? true : false;

            if ( valor === null ) { 
                $('.modal').modal('hide');

                this.valor_do_adiantamento = null;
                this.validate = false;

                this.$nextTick(() => { 
                    this.valor_do_adiantamento = 0;
                    this.data_do_adiantamento = this.$util.hoje();
                    $('#valorAdiantamentoModal').modal('show');
                });

                return;
            }

            this.validate = true;

            this.$nextTick(() => {

                let invalids = $('#valorAdiantamentoModal .invalid');

                if (invalids.length && $(".invalid").is(":visible")) {
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Verificar preenchimento dos campos.",
                        life: 3000
                    });
                    return;
                }

                $('.modal').modal('hide');

                this.novo = true;

                this.$nextTick(() => { 

                    if ( this.dados.fornecedor ) { 
                        this.$refs.pag.adiantamento(
                            valor, 
                            { 
                                id_fornecedor: this.dados.fornecedor.id_fornecedor,
                                pendente: pendente, 
                                data_pag: this.data_do_adiantamento,
                            }
                        );
                    } else { 
                        this.$refs.pag.adiantamento(
                            valor, 
                            { 
                                id_paciente: this.dados.paciente.id_pessoa > 0 ? this.dados.paciente.id_pessoa : null,
                                id_cadastro_temporario: this.dados.paciente.id_cadastro_temporario, 
                                pendente: pendente, 
                                data_pag: this.data_do_adiantamento,
                                id_plano_particular: this.id_plano_particular, 
                                id_orcamento: this.dados.orcamento ? this.dados.orcamento.id_orcamento : null, 
                                medico: this.medico_adiantamento, 
                            }
                        );
                    }
                });

            });
        },

        sigla(item) { 
            return item.atendimento_procedimento.procedimento.st_sigla 
                ? item.atendimento_procedimento.procedimento.st_sigla 
                : item.atendimento_procedimento.procedimento.st_procedimento;
        },

        tem_laudo_pronto(lista) { 
            return lista.find(item => item && item.status_laudo && item.status_laudo.fl_pronto) ? true : false;
        },

        imprimir_lab(laudo) { 
            this.$util.print_preview('imprimir/laudo_lab/' + laudo.atendimento_procedimento.id_atendimento, true);
        },

        imprimir(laudo) { 
            if ( !laudo.status_laudo.fl_pronto ) { 
                this.$toast.add({
                    severity: "warn",
                    summary: laudo.atendimento_procedimento.procedimento.search,
                    detail: "Laudo: " + laudo.status_laudo.search,
                    life: 3000
                });
                return;
            }

            this.$util.print_preview('imprimir/laudo/' + laudo.id_laudo, true);
        },

        imprimir_etiqueta(laudo) { 
            if ( !this.layout ) { 
                return;
            }

            this.$util.print_preview('imprimir/etiqueta/' + laudo.id_laudo + '/' + this.layout, true);
        },

        dados_procedimento(laudo) { 
            return { 
                marcacao: { 
                    procedimento: laudo.atendimento_procedimento.procedimento,
                    medico: laudo.atendimento_procedimento.atendimento.medico, 
                    arquivos: laudo.atendimento_procedimento.atendimento.marcacao.arquivos,
                    doc_pre_atends: laudo.atendimento_procedimento.atendimento.marcacao.doc_pre_atends, 
                    unidade_operacao: laudo.atendimento_procedimento.atendimento.marcacao.unidade_operacao, 
                }
            };
        },

        selecionarPaciente() { 
            this.dados.fornecedor = null;

            if ( this.idpaciente ) { 
                return;
            }

            this.novo = null;

            this.$nextTick(() => { 
                this.load();
            });
        },

        load(refresh = false) { 

            if ( !refresh ) { 
                this.dados.pagamentos = null;
            }

            if ( this.dados.fornecedor ) { 

                if ( this.canceltoken ) {
                    this.canceltoken.cancel('#BC#');
                }

                this.canceltoken = this.axios.CancelToken.source();
                
                this.$util.load(this, { 
                    service: 'pagamentos',
                    func: 'index',
                    parms: { 
                        id_fornecedor: this.dados.fornecedor.id_fornecedor, 
                    },
                    canceltoken: this.canceltoken.token,
                    loadTo: res => { 
                        this.dados.pagamentos = res;
                        this.$forceUpdate();
                    }
                });

                return;
            }

            let id;
            let idtemp;

            if ( this.idpaciente ) { 

                if ( isNaN(this.idpaciente) && this.idpaciente.substr(0,1) == 'p' ) { 
                    id = parseInt(this.idpaciente.substr(1)) * -1;
                    idtemp = parseInt(this.idpaciente.substr(1));
                } else { 
                    id = this.idpaciente;
                }

            } else { 

                id = ( this.dados.paciente ? this.dados.paciente.id_pessoa : null );
                idtemp = ( id < 0 && this.dados.paciente ) ? this.dados.paciente.id_cadastro_temporario : null; 

            }

            if ( !id )
                return;

            if ( this.canceltoken ) {
                this.canceltoken.cancel('#BC#');
            }

            this.canceltoken = this.axios.CancelToken.source();

            let id_atds = this.$route.params.id_atds ? this.$route.params.id_atds : null;

            this.$util.load(this, { 
                service: 'pagamentos',
                func: 'index',
                parms: { 
                    id_paciente: id, 
                    id_cadastro_temporario: idtemp, 
                    id_atds: id_atds
                },
                canceltoken: this.canceltoken.token,
                loadTo: res => { 
                    if ( id_atds && id_atds.length ) { 
                        res.atendimentos.forEach(atd => {
                            if ( !atd.pagamento ) { 
                                atd.marcacao.status_confirmacao = true;
                            }
                        });
                    }

                    this.dados.pagamentos = res;

                    if ( this.idpaciente ) {    
                        this.dados.paciente = res.paciente;
                    }

                    this.$forceUpdate();

                    if ( this.id_orcamento ) { 
                        this.pos_orcamento();
                    } else if ( this.id_pagamento_atendimento && this.primeira_vez ) { 
                        this.primeira_vez = false;
                        this.abrir_pagamento(this.id_pagamento_atendimento);
                    }

                }
            });

        },

        teste() { 
            this.$util.load(this, { 
                service: 'amostras',
                func: 'teste',
                loadTo: res => { 
                    console.log(res);
                }
            });
        },

        pos_orcamento() { 
            if ( this.orcamento_carregado )
                return;

            this.$nextTick(() => { 
                $('#myTab a[href="#adiantamento"]').tab('show');
            });

            // if ( this.)

            if ( this.dados && this.dados.pagamentos && this.dados.pagamentos.adiantamentos ) { 
                let teste = this.dados.pagamentos.adiantamentos.find(item => item.id_pagamento_atendimento == this.dados.orcamento.id_pagamento_atendimento);

                if ( teste ) { 
                    this.orcamento_carregado = true;
                    return;        
                }

            }

            this.medico_adiantamento = _.get(this.dados.orcamento, 'js_procedimentos.0.medico');

            this.novo_adiantamento(( this.dados && this.dados.orcamento ) ? this.dados.orcamento.valor_final : 0);

            this.orcamento_carregado = true;
        }
    },

    mounted() { 

        if ( !this.view ) { 
            if ( this.is_callcenter ) { 
                this.$store.commit("setBreadcrumb", [
                    { name: "Call Center", path: "/call-center" },
                    { name: "Pagamento Particular", path: "/call-center/adiantamento" }
                ]);
            } else { 
                this.$store.commit("setBreadcrumb", [
                    { name: "Recepção", path: "/recepcao" },
                    { name: "Pagamento Particular", path: "/recepcao/adiantamento" }
                ]);
            }
        }

        if ( this.idpaciente ) { 

            this.load();

        } else if ( this.id_orcamento ) { 

            // ORÇAMENTO 
            this.$util.loadItem(this, { 
                service: 'orcamentos',
                func: 'show', 
                parms: { 
                    id: this.id_orcamento, 
                    adiantamento: true, 
                }
            })
            .then(res => { 
                if ( res.paciente ) { 
                    this.dados.paciente = res.paciente;
                    this.dados.orcamento = res;
                } else if ( res && res.marcacoes && res.marcacoes.length ) { 
                    let cad_temp = res.marcacoes[0].cadastro_temporario;

                    if ( cad_temp ) { 

                        cad_temp.id_pessoa = -1;

                        this.dados.paciente = cad_temp;
                        this.dados.orcamento = res;

                    } else if ( res.marcacoes[0].paciente ) { 

                        this.dados.paciente = res.marcacoes[0].paciente;
                        this.dados.orcamento = res;

                    }

                    if ( res.id_plano ) { 
                        this.id_plano_particular = res.id_plano;
                    }
                    
                }

                console.log('DD', this.dados);
            });

        } else if ( this.id_marcacao ) { 

            // Marcação
            this.$util.loadItem(this, { 
                service: 'marcacoes',
                func: 'show', 
                parms: { 
                    id: this.id_marcacao, 
                    pagamento: true, 
                }
            })
            .then(res => { 
                if ( res.paciente ) { 
                    this.dados.paciente = res.paciente;
                    this.dados.marcacao = res;
                }
            });

        } else { 

            // FORNECEDORES
            this.$util.loadItem(this, { 
                service: 'planos',
                func: 'index', 
                parms: { 
                    tem_fornecedor: true, 
                }
            })
            .then(res => { 
                if ( res && res.length ) { 
                    this.tem_fornecedor = true;
                }
            });

        }

    },
    
    updated() {
        $('[data-toggle="tooltip"]').tooltip();
    },
}
</script>